import React from "react";
import HeaderInner from "../header/HeaderInner";
import BreadcrumbSd from "../inner//breadcrumb/BreadcrumbSd";
import Footer from "../elements/Footer";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";

// Data
import { DataContactOne } from "../data/DataContact";
import { DataNav } from "../data/DataNav";
import { DataService } from "../data/DataService";

function ServiceDetails({ id }) {
  const active = {
    color: "#fff",
    background: "var(--color-primary)",
  };

  return (
    <div className="service-details">
      <div className="">
        <HeaderInner />
        <main>
          <BreadcrumbSd id={id} />
          {/* tmp service section */}
          <div className="tmp-service-section tmp-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="tmp-large-service-detials">
                    <img
                      src={DataService[`item${id}`]?.cover}
                      alt="corporate_business_details"
                    />
                  </div>
                  {/* single service details component */}
                  <div className="single-service-details-component mt--40">
                    <h2 className="title split-collab">
                      {DataService[`item${id}`]?.title}
                    </h2>
                    <p className="disc mb--20">
                      {DataService[`item${id}`]?.desc}
                    </p>
                  </div>
                  {/* single service details component end */}

                  <div className="row g-5 mt--10">
                    <div className="col-lg-12"></div>
                    <div className="col-lg-6">
                      <div className="row">
                        {DataService[`item${id}`].gallery.map((item) => {
                          return (
                            <div
                              key={item.id}
                              className="col-lg-6 col-md-6 col-sm-6"
                            >
                              <div className="single-service-details-thumb">
                                <img src={item.img} alt="" />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="service-detials-thumb-details">
                        {DataService[`item${id}`].actions?.map((item) => {
                          return (
                            <div key={item.id} className="single-check">
                              <i className="fa-light fa-circle-check" />
                              <p>{item.action}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                  <div className="side-bar-details-page">
                    {/* single bar */}
                    <div className="signle-side-bar category-area">
                      <div className="header">
                        <h3 className="title">Départements</h3>
                      </div>
                      <div className="body">
                        {/* single category */}

                        {/* single category end */}

                        {DataNav[2].depDetails.map((item) => {
                          return (
                            <Link
                              key={item.id}
                              to={`/detail_departement_${item.id}`}
                              className="single-category"
                              style={item.id === id ? active : {}}
                            >
                              <p
                                style={item.id === id ? { color: "#fff" } : {}}
                              >
                                {item.label}
                              </p>
                              <i className="fa-light fa-arrow-right" />
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                    {/* single bar end */}
                    {/* single bar */}
                    <div className="signle-side-bar call-to-action">
                      <div className="easy-call-to-action">
                        <div className="icon-center-call">
                          <i className="fa-light fa-phone" />
                        </div>
                        <h3 className="title">{DataContactOne.needHelp}</h3>
                        <p className="disc">{DataContactOne.needHelpDesc}</p>
                        <Link to={`tel:${DataContactOne.phone}`}>
                          {DataContactOne.phone}
                        </Link>
                        <br />
                        <Link to={`tel:${DataContactOne.phone2}`}>
                          {DataContactOne.phone2}
                        </Link>
                      </div>
                    </div>
                    {/* single bar end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* tmp service section end */}
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default ServiceDetails;
